import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import {
  failureGetVehicle,
  failureGetVehicleSearch,
  successGetVehicle,
  successGetVehicleSearch,
} from "./VehicleSlicer";
import { IVehicleList } from "../../../Pages/Vehicle/Ivehicle";
import { PayloadAction } from "@reduxjs/toolkit";
import { failureAddVehicle, successAddVehicle } from "./AddVehicleSlicer";
import {
  failureUpdateVehicle,
  successUpdateVehicle,
} from "./UpdateVehicleSlicer";
import {
  failureDeleteVehicle,
  successDeleteVehicle,
} from "./DeleteVehicleSlice";
import { act } from "@testing-library/react";

const VehicleApi = () => {
  return api.get("/vehicle");
};

export function* VehicleCall() {
  try {
    const response: AxiosResponse = yield call(VehicleApi);
    yield put(successGetVehicle(response.data));
  } catch (error) {
    yield put(failureGetVehicle(error));
  }
}

const VehicleSearchApi = (action: PayloadAction<IVehicleList>) => {
  console.log(action.payload);

  return api.get(`/vehicle/list?search=${action.payload}`);
};

export function* VehicleSearchCall(action: PayloadAction<IVehicleList>) {
  try {
    const response: AxiosResponse = yield call(VehicleSearchApi, action);
    yield put(successGetVehicleSearch(response.data));
  } catch (error) {
    yield put(failureGetVehicleSearch(error));
  }
}
// add Vehicle
const AddVehicleApi = (action: PayloadAction<IVehicleList>) => {
  return api.post('/vehicle/create', action.payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export function* AddVehicleCall(action: PayloadAction<IVehicleList>) {
  try {
    const response: AxiosResponse = yield call(AddVehicleApi, action);
    yield put(successAddVehicle(response.data));
  } catch (error) {
    yield put(failureAddVehicle(error));
  }
}

// update Vehicle
const UpdateVehicleApi = (action: PayloadAction<IVehicleList>) => {
  // const formData = new FormData();

  // Object.entries(action.payload).forEach(([key, value]) => {
  //   formData.append(key, value);
  // });
  const url = `/vehicle/${action.payload.id}`;

  return api.patch(url, action.payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export function* UpdateVehicleCall(action: PayloadAction<IVehicleList>) {
  try {
    const response: AxiosResponse = yield call(UpdateVehicleApi, action);
    yield put(successUpdateVehicle(response.data));
  } catch (error) {
    yield put(failureUpdateVehicle(error));
  }
}

// delete Vehicle
const DeleteVehicleApi = (action: PayloadAction<number>) => {
  return api.delete(`/vehicle/${action.payload}`);
};
export function* DeleteVehicleCall(action: PayloadAction<number>) {
  try {
    const response: AxiosResponse = yield call(DeleteVehicleApi, action);
    yield put(successDeleteVehicle(response.data));
  } catch (error) {
    yield put(failureDeleteVehicle(error));
  }
}
